import { render } from "./PaymentMethod.vue?vue&type=template&id=288027ba&scoped=true&ts=true"
import script from "./PaymentMethod.vue?vue&type=script&lang=ts"
export * from "./PaymentMethod.vue?vue&type=script&lang=ts"

import "./PaymentMethod.vue?vue&type=style&index=0&id=288027ba&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288027ba"]])

export default __exports__